<script lang="typescript">
    import { onDestroy } from "svelte";
    import { scale } from "svelte/transition";

    onDestroy(() => window.scrollTo(0, 0));
</script>

<section
    class="justify-center h-screen overflow-y-hidden bg-center bg-contain bg-no-repeat"
    style="background-image: url('/img/promotions/eyezenkids.png')"
>
    <div
        class="
          w-full
          items-end
          justify-start
          absolute
          bottom-0
          flex"
    >
        <div
            class=" z-35 text-2xl p-4 opacity-95 bg-white"
            in:scale={{ start: 1.5, duration: 500, delay: 500 }}
        >
            <div class="ml-8 mr-4 mt-4 text-black">
                <h2 class="text-3xl">Please note:</h2>
                <p>For all the dispense codes please refer to the Customised Mode Lens Selection</p>
                <p>
                    For this please click on the link:
                    <a href="https://automotiverecommenderwb.visionexpress.com/LR/ExpertMode"
                        >https://automotiverecommenderwb.visionexpress.com/LR/ExpertMode</a
                    >
                </p>
            </div>
        </div>
    </div>
</section>

<style>
</style>
